// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3fZOb","unknownRecipe":"style_unknownRecipe__3cg7Z","colorWheelImage":"style_colorWheelImage__6e33n"};